import { GraphQLNonNull, GraphQLString, GraphQLID } from 'graphql'
import { Context } from '../shared'
import { ContrastGraphQLFieldConfig } from '..'
import {
  vulnerabilityPolicyType,
  VulnerabilityPolicy
} from '../types/vulnerability-policy'
import { normalizeVulnerabilityPolicy } from './helpers/vulnerability'

interface VulnerabilityPolicyArgs {
  readonly organizationID: string
  readonly policyID: string
}

const vulnerabilityPolicyArgs = {
  organizationID: {
    description: 'The unique ID for the organization being queried',
    type: new GraphQLNonNull(GraphQLID)
  },
  policyID: {
    description: 'The unique ID for the policy being queried',
    type: new GraphQLNonNull(GraphQLString)
  }
}

export const vulnerabilityPolicy: ContrastGraphQLFieldConfig<
  any,
  Context,
  VulnerabilityPolicyArgs,
  VulnerabilityPolicy
> = {
  description: 'Get vulnerability policy by Organization and policy ID',
  type: new GraphQLNonNull(vulnerabilityPolicyType),
  args: vulnerabilityPolicyArgs,
  async resolve(_source, args, context) {
    const { organizationID, policyID } = args

    const { policy } = await context.connector.get(
      `${organizationID}/policy/remediation/${policyID}`
    )
    return normalizeVulnerabilityPolicy(policy)
  }
}
